export const RedirectedCall: {
  name: 'redirected_call-8b8e4d00def7'
} = {
  name: 'redirected_call-8b8e4d00def7'
}
